import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { AttributeInterface } from 'src/app/model/attributes/attribute-interface';
import { ProductService } from 'src/app/services/dataServices/product-service/productService';
import { CertificationService } from 'src/app/services/dataServices/certification-service/certificationService';
import { AttributeValidationServiceService } from 'src/app/services/dataServices/dataValidation/attribute-validation-service/attribute-validation-service.service';
import { ChangeDetectorRef } from '@angular/core';

@Component({
    selector: 'app-attribute-validation-panel',
    templateUrl: './attribute-validation-panel.component.html',
    styleUrls: ['./attribute-validation-panel.component.scss'],
    standalone: false
})
export class AttributeValidationPanelComponent implements OnInit {
    @Input() editable?: boolean;
    @Input() optional?: boolean;
    @Input() ptgName: string;

    @Input() set attributes(attributes: AttributeInterface[]) {
        this.attributes_ = attributes;
        this.attributes_.sort((a, b) =>
            a.name.toLowerCase().localeCompare(b.name.toLowerCase())
        );
            setTimeout(() => {
                this.updateAllSelectedState();
                this.cdr.detectChanges();
            }, 100);
    }

    get attributes(): AttributeInterface[] {
        return this.attributes_;
    }

    private attributes_: AttributeInterface[];

    @Input() showOrderControls: boolean = false;
    @Input() canMoveUp: boolean = true;
    @Input() canMoveDown: boolean = true;
    @Input() position: number;

    @Output() moveUp = new EventEmitter<void>();
    @Output() moveDown = new EventEmitter<void>();
    
    @Output() attributesChanged: EventEmitter<AttributeInterface[]> =
    new EventEmitter<AttributeInterface[]>();

    allSelected = false;
    
    constructor(
        public attributeValidationService: AttributeValidationServiceService,
        public productService: ProductService,
        public certificationService: CertificationService,
        private cdr: ChangeDetectorRef
    ) {}

    ngOnInit(): void {
        this.attributeValidationService.loadValidation(
            this.attributes,
            this.optional
        );   

        setTimeout(() => {
            this.updateAllSelectedState();
            this.cdr.detectChanges();
        }, 50);
    }

    removeAttribute(attribute: AttributeInterface): void {
        const validationId = attribute.validations[0].id;
        this.attributes = this.attributes.filter((attribute) => {
            return attribute.validations[0].id !== validationId;
        });
        this.attributesChanged.emit(this.attributes);
    }

    public hasAttributeConflict(attribute: AttributeInterface): boolean {
        return this.attributeValidationService.hasAttributeConflict(
            attribute.id
        );
    }

    public getConflictErrorMessage(attribute: AttributeInterface): string {
        const isOptional =
            this.attributeValidationService.isAttributeEffectivelyOptional(
                attribute.id
            );
        const attributeName = attribute.name;
        let conflictMessage =
            'Es wurden mehrere Validierungen für das Merkmal ' +
            attributeName +
            ' ausgewählt, welche nicht gleichzeitig erfüllt werden können.';
        if (isOptional) {
            conflictMessage +=
                ' Da es sich um ein optionales Merkmal handelt, ist nur keine Angabe valide';
        }
        return conflictMessage;
    }
    
    onAttributeValueChange(
        attribute: AttributeInterface,
        newValue: string
    ): void {        
        this.attributeValidationService.modelChangedIsOptional(
            attribute,
            attribute.validations[0],
            newValue
        );
        
        this.updateAllSelectedState();
        this.attributesChanged.emit(this.attributes);
        this.cdr.detectChanges();
    }

    toggleAllAttributes(selected: boolean): void {
        this.allSelected = selected;

        // -> erst mal checken wann es zu Konflikten kommt???
        // const hasSelectableAttributes = this.attributes.some(
        //     attr => !this.hasAttributeConflict(attr)
        // );
        
        // if (!hasSelectableAttributes) {
        //     return;
        // }
        for (const attribute of this.attributes) {
            if (!this.hasAttributeConflict(attribute)) {
                const value = selected ? 'true' : 'false';
                this.onAttributeValueChange(attribute, value);
            }
        }
    }

    private updateAllSelectedState(): void {
        if (!this.attributes || this.attributes.length === 0) {
            this.allSelected = false;
            return;
        }

        const selectableAttributes = this.attributes.filter(
            attr => !this.hasAttributeConflict(attr)
        );
        
        if (selectableAttributes.length === 0) {
            this.allSelected = false;
            return;
        }

        this.allSelected = selectableAttributes.every(attribute => {
            const value = this.attributeValidationService.activeEntityFeatureValues.get(attribute.id);
            return value === 'true';
        });
    }


    onMoveUp(): void {
        this.moveUp.emit();
    }
    
    onMoveDown(): void {
        this.moveDown.emit();
    }

}
